import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Environment } from 'dashboard/models/environment';
import { ExporterAttributes, ExporterFileType, ExporterReport } from 'dashboard/models/exporter';
import { Report } from 'dashboard/models/report';
import { ReportsFilterParams, setReports } from 'dashboard/redux/actions/reports';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadReportsList({
  currentEnvironment,
  currentPage,
  pageSize,
  sortParams,
  filters,
  abortSignal,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  sortParams: SortParams;
  filters: ReportsFilterParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const params = createParamsForList(currentEnvironment, filters, sortParams);
    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    };

    const reportsResponse = await SessionClientDashboard.listResource<Report, PaginationParams>(
      ApiEndpoint.Report,
      paramsFull,
    );

    const reports = reportsResponse.data;
    const paginationParams = reportsResponse.meta;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setReports(reports, currentEnvironment, paginationParams));
  };
}

function createParamsForList(
  currentEnvironment: Environment,
  reportFilters: ReportsFilterParams,
  reportSortParams: SortParams,
  fileType?: ExporterFileType,
) {
  const {
    createdAtStart,
    createdAtEnd,
    status,
    matchResult,
    reportTemplateIds,
    tagIds,
    omni,
    conditions,
  } = reportFilters;
  const { sort, shouldSortDescending } = reportSortParams;

  return {
    'file-type': fileType || ExporterFileType.TarGz,
    filter: {
      'environment-id': currentEnvironment.id,
      'created-at-start': createdAtStart?.toString(),
      'created-at-end': createdAtEnd?.toString(),
      status,
      matchResult,
      'report-template-ids': reportTemplateIds,
      'tag-ids': tagIds,
      omni,
      conditions,
    },
    sort: `${shouldSortDescending ? '-' : ''}${sort}`,
  };
}

export const loadExporterReport =
  ({
    currentEnvironment,
    filters,
    sortParams,
    fileType,
  }: {
    currentEnvironment: Environment;
    filters: ReportsFilterParams;
    sortParams: SortParams;
    fileType: ExporterFileType;
  }) =>
  async () => {
    const params = createParamsForList(currentEnvironment, filters, sortParams, fileType);

    await SessionClientDashboard.postResourceCreate<
      ExporterReport,
      { type: ApiModel.ExporterReport; attributes: ExporterAttributes }
    >({
      type: ApiModel.ExporterReport,
      attributes: {
        ...params,
      },
    });
  };
